module.exports = __webpack_public_path__ + "img/start_stopwatch.6f17be4a.svg";